import { PicklistInfo } from './PicklistInfo';

export default PicklistInfo;
